import React, { useState } from 'react';
import { AppBar, Box, Drawer, List, ListSubheader, Divider, ListItemButton, ListItemIcon, ListItemText, Button, IconButton, Toolbar } from '@mui/material';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { logout } from '@/store/auth/authSlice';
import { CalendarMonthOutlined, FeedbackOutlined, HomeOutlined, MenuOutlined, SearchOutlined } from '@mui/icons-material';

import FeedbackDialog from '@/components/Feedback/FeedbackDialog';
import NotificationsButton from '@/components/Notifications/NotificationsButton';

const languages = [
  { code: 'fi', label: 'FI', flag: '🇫🇮' },
  { code: 'en', label: 'EN', flag: '🇬🇧' },
];

const TopBar = () => {
  const [navigationMenu, setNavigationMenu] = useState(null);
  const [feedbackOpen, setFeedbackOpen] = useState(false);
  const dispatch = useDispatch();
  // @ts-ignore
  const { token } = useSelector(state => state.auth);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const handleOpen = e => setNavigationMenu(e.currentTarget);
  const handleClose = () => setNavigationMenu(null);

  const handleLogout = () => {
    dispatch(logout());
    handleClose();
    navigate('/login', { replace: true });
  };

  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem('varauslite-language', lang);
  };

  return (
    <React.Fragment>
      <Box>
        <AppBar position="fixed" sx={{ backgroundColor: 'white', maxHeight: '10%' }}>
          <Toolbar>
            <Box sx={{ mr: 2, flexGrow: 1, minWidth: 0, display: 'flex', alignItems: 'center', overflow: 'hidden' }}>
              <img
                src="/assets/sportum_travelnet.png"
                alt="Sportum TravelNet"
                style={{ width: '60%', maxWidth: 240, maxHeight: 48, height: 'auto', display: 'block' }}
              />
            </Box>
            {token && (
              <>
                <NotificationsButton />
                <IconButton size="large" aria-label="menu" onClick={handleOpen}>
                  <MenuOutlined />
                </IconButton>
              </>
            )}
            <Drawer open={navigationMenu} onClose={handleClose} anchor="right">
              <Box sx={{ width: '66vw', maxWidth: 400, height: '100vh', display: 'flex', flexDirection: 'column' }}>

                <List
                  subheader={<ListSubheader component="div">{t('topbar.menu')}</ListSubheader>}
                  sx={{ flex: 1 }}
                >
                  <Divider />
                  <ListItemButton component={RouterLink} to="/dashboard" onClick={handleClose}>
                    <ListItemIcon><HomeOutlined /></ListItemIcon>
                    <ListItemText primary={t('topbar.homepage')} />
                  </ListItemButton>
                  <ListItemButton component={RouterLink} to="/koriHaku" onClick={handleClose}>
                    <ListItemIcon><SearchOutlined /></ListItemIcon>
                    <ListItemText primary={t('topbar.korisearch')} />
                  </ListItemButton>
                  <ListItemButton component={RouterLink} to="/kalenteri" onClick={handleClose}>
                    <ListItemIcon><CalendarMonthOutlined /></ListItemIcon>
                    <ListItemText primary={t('topbar.calendars')} />
                  </ListItemButton>
                  <ListItemButton onClick={() => setFeedbackOpen(true)}>
                    <ListItemIcon><FeedbackOutlined /></ListItemIcon>
                    <ListItemText primary={t('topbar.feedback')} />
                  </ListItemButton>
                </List>

                <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 1 }}>
                  <Divider />
                  <Button component={RouterLink} variant="outlined" to="/kayttaja" onClick={handleClose}>
                    Käyttäjätiedot
                  </Button>
                  <Box sx={{ display: 'flex', gap: 1, py: 0.5 }}>
                    {languages.map(({ code, label, flag }) => (
                      <Button
                        key={code}
                        onClick={() => handleLanguageChange(code)}
                        variant={i18n.language === code ? 'contained' : 'outlined'}
                        size="small"
                        sx={{ gap: 0.75, flex: 1, textTransform: 'none', fontSize: '0.875rem' }}
                      >
                        <span style={{ fontSize: '1.1rem', lineHeight: 1 }}>{flag}</span>
                        {label}
                      </Button>
                    ))}
                  </Box>

                  <Button variant="contained" onClick={handleLogout} fullWidth>
                    {t('topbar.logout')}
                  </Button>
                </Box>

              </Box>
            </Drawer>
          </Toolbar>
        </AppBar>
        <Toolbar />
      </Box>
      <FeedbackDialog open={feedbackOpen} onClose={() => setFeedbackOpen(false)} />
    </React.Fragment>
  );
};

export default TopBar;
